<template>
    <div class="operation_box">
        <!-- Document Download -->
        <div class="operation_item" v-if="shouldDisplayDownloadButton">
            <el-dropdown split-button type="primary"
                         @click="handleDocumentsDownload"
                         @command="(command) => command()"
            >
                <i class="fa fa-cloud-download"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="fa fa-cloud-download" :command="handleDocumentsDownload">
                        <span>{{ $t("common.all") }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-for="(enumProp, enumValue) in enumDef.assignmentDocumentType.properties"
                                      :key="enumValue"
                                      :icon="enumProp.icon">
                        <a :href="buildDocumentDownloadUrl(Number(enumValue))" target="_blank">
                            {{ $t(enumProp.key) }}
                        </a>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>

import {enumDef} from "@/common/enumDefs";
import {fileuploadApi} from "@/common/api/fileuploadApi";

export default {
    data() {
        return {
            enumDef: enumDef,
        };
    },
    computed: {
    	shouldDisplayDownloadButton() {
			return this.params.data.assignmentId
        }
    },
    methods: {
        handleDocumentsDownload() {
            this.params.downloadDocuments(this.params.data);
        },
        buildDocumentDownloadUrl(documentType) {
            let fileId;

            switch (documentType) {
                case enumDef.assignmentDocumentType.AssignmentContract:
                    fileId = this.params.data.assignmentDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.AdviceOfSettlement:
                    fileId = this.params.data.assignmentInvoiceDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.ServiceInvoice:
                    fileId = this.params.data.assignmentServiceInvoiceDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.TransactionPdf:
                    fileId = this.params.data.assignmentTransactionDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.AccountingCsv:
                    fileId = this.params.data.accountingCsvDocumentFileId;
                    break;
            }

            return fileuploadApi.getPdfUrl(fileId);
        },
    }
};
</script>